import { resolveImagePath } from '@/utils/imageResolver';

export function TrainingJourney() {
  const cockpitImage = resolveImagePath('/images/pilot-school.jpg');

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="flex flex-col lg:flex-row items-center gap-12">
          {/* Content Column */}
          <div className="lg:w-1/2 space-y-6">
            <h2 className="text-4xl lg:text-5xl font-bold text-primary leading-tight">
              Start Your Journey Here!
            </h2>
            
            <p className="text-lg text-text-secondary leading-relaxed">
              If you're local, out of state or international, we'll help you achieve your goals.
            </p>
            
            <div className="pt-4">
              <a
                href="/courses"
                className="inline-flex items-center justify-center px-8 py-3 bg-accent text-white font-semibold rounded-md hover:bg-opacity-90 transition-colors duration-200"
              >
                View Courses
              </a>
            </div>
          </div>

          {/* Image Column */}
          <div className="lg:w-1/2">
            <div className="relative">
              <img
                src={cockpitImage}
                alt="Pilot school - cockpit view"
                className="w-full h-auto rounded-lg shadow-lg object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}